/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionStateFromJSON, ApiConversionStateToJSON, } from './ApiConversionState';
export function ApiConversionStateResponseFromJSON(json) {
    return ApiConversionStateResponseFromJSONTyped(json, false);
}
export function ApiConversionStateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !exists(json, 'result') ? undefined : ApiConversionStateFromJSON(json['result']),
    };
}
export function ApiConversionStateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': ApiConversionStateToJSON(value.result),
    };
}
